import { chunkAndBase64Blob, dataURItoBlob } from './chunkAndBase64Blob.js';
import { v4 as uuidv4 } from 'uuid';
import { parseUrl } from './moo.js';

//tap页面链接按钮转化 web链接向端内uri转换
export function getHrefInTapTap(href) {
  if (!window) return href;
  if (!window.moo.getUrl) return href; //非tap页面不进入以下逻辑
  if (href.indexOf('#') === 0) return href; //锚点链接不进入以下逻辑
  if (
    href.indexOf('tapglobal://taptap.tw') === 0 ||
    href.indexOf('taptap://taptap.com') === 0
  ) {
    //有问题的时候 可以用这种配置快速兜底
    return href;
  }
  let ret = href;
  let url = parseUrl(href);
  let params = {};
  let origin = href;
  if (url?.search) {
    let obj = {};
    let searchParams = url.searchParams;
    for (let pair of searchParams.entries()) {
      if (pair[1]) {
        obj[pair[0]] = pair[1];
      }
    }
    origin = ret.split('?')[0];
    params = obj;
  }
  if (url.hostname === 'www.taptap.cn' || url.hostname === 'www.taptap.io') {
    //兼容运营配置完整地址的写法
    origin = url.pathname;
  }
  origin = origin.trim();
  ret = window.moo.getUrl(origin, params);
  return ret;
}

//获取Tap用户ID
export function getTapUserId() {
  return window.moo.getCookie('user_id');
}

//获取客户端XTP
export function getClientXTP() {
  return clientApi('getClientXTP', '');
}

//获取Tap环境变量
export function getTapEnv(type) {
  if (window?.moo?.CONSTANT.IS_IN_TAPTAP) {
    var tapEnv = clientApi('tapEnv');
    var ret = tapEnv && JSON.parse(tapEnv)[type];
    const num_key = ['VN_CODE', 'VERSION_RELEASE', 'VERSION_SDK_INT'];
    if (num_key.indexOf(type) > -1) {
      return ret ? Number(ret) : 0;
    } else {
      return ret ? ret : '';
    }
  }
  return undefined;
}

//保存图片至本地
function saveImageToAlbum(_img) {
  if (!window?.moo?.CONSTANT.IS_IN_TAPTAP) {
    return;
  }
  if (!hasTapClientApi('saveImage')) {
    console.log('请升级到新版本体验该功能');
    return;
  }
  if (_img && _img.length > 0) {
    const INLINE_BASE64 = /^data:image\/.*;base64,/i;
    if (INLINE_BASE64.test(_img)) {
      saveBlobImage(_img, true).then((params) => {
        clientApi('showToast', '保存成功');
      });
    } else {
      saveRemoteImage(_img, true).then((params) => {
        clientApi('showToast', '保存成功');
      });
    }
  }
}

//打开tap图文发布器
function openTapTapMomentEditor(
  _img,
  _title,
  _content,
  _app_id,
  _hashtag_ids,
  _group_label_id,
  _saveImageToAlbum,
  _is_public
) {
  if (!window?.moo?.CONSTANT.IS_IN_TAPTAP) {
    return;
  }
  if (!_saveImageToAlbum) {
    _saveImageToAlbum = false;
  }
  window.moo.TAPTAP.momentEditorInfo = {
    title: _title,
    content: _content,
    app_id: _app_id,
    hashtag_ids: _hashtag_ids,
    group_label_id: _group_label_id,
    image_ids: [],
    is_public: _is_public ? 1 : 0,
  };
  if (_img && _img.length > 0 && hasTapClientApi('saveImage')) {
    const INLINE_BASE64 = /^data:image\/.*;base64,/i;
    if (INLINE_BASE64.test(_img)) {
      saveBlobImage(_img, _saveImageToAlbum).then((params) => {
        window.moo.TAPTAP.momentEditorInfo.image_ids.push(params['imageId']);
        openClientMomentEditor();
      });
    } else {
      saveRemoteImage(_img, _saveImageToAlbum).then((params) => {
        window.moo.TAPTAP.momentEditorInfo.image_ids.push(params['imageId']);
        openClientMomentEditor();
      });
    }
  } else {
    openClientMomentEditor();
  }
}

function openClientMomentEditor() {
  const momentEditorInfo = window.moo.TAPTAP.momentEditorInfo;
  momentEditorInfo.hashtag_ids = momentEditorInfo.hashtag_ids.filter((item) => {
    return item !== null && typeof item !== 'undefined' && item !== '';
  });
  const uriToMomentEditor = `taptap://taptap.com/editor/moment?title=${encodeURIComponent(
    momentEditorInfo.title
  )}&contents=${encodeURIComponent(momentEditorInfo.content)}&app_id=${
    momentEditorInfo.app_id
  }&group_label_id=${momentEditorInfo.group_label_id}&hashtag_ids=${
    momentEditorInfo.hashtag_ids
  }&image_ids=${momentEditorInfo.image_ids.join(',')}&is_public=${
    momentEditorInfo.is_public
  }`;
  window.location.href = uriToMomentEditor;
}

const saveImageCallbackMap = new Map();

function saveImage(params) {
  if (hasTapClientApi('saveImage')) {
    clientApi('saveImage', params);
  } else {
    console.log('请升级到新版本体验该功能');
  }
}

function saveBlobImage(base64Data, saveAlbum) {
  return new Promise((resolve) => {
    const imageId = uuidv4().slice(-12);
    const blob = dataURItoBlob(base64Data);
    chunkAndBase64Blob(blob, 750).then((chunks) => {
      const params = {};
      params['imageId'] = imageId;
      params['chunks'] = chunks.length;
      let index = 0;
      for (const chunk of chunks) {
        params['chunkIndex'] = index;
        params['base64Data'] = chunk;
        params['saveAlbum'] = saveAlbum;
        params['mimeType'] = blob.type;
        saveImage(params);
        index++;
      }
    });

    saveImageCallbackMap.set(imageId, (params) => {
      resolve(params);
    });
  });
}

function saveRemoteImage(url, saveAlbum) {
  return new Promise((resolve) => {
    const imageId = uuidv4().slice(-12);
    saveImage({
      imageId: imageId,
      remoteUrl: url,
      saveAlbum: saveAlbum,
    });

    saveImageCallbackMap.set(imageId, (params) => {
      resolve(params);
    });
  });
}

export function getShareUrl() {
  let ret = window.location.href;
  if (ret.indexOf('share_id') < 0) {
    // 如果二维码里没有 share_id，强行生成一个
    let newUrl = new URL(ret);
    newUrl.searchParams.set('share_id', getShareId());
    ret = newUrl.href;
  }
  let newUrl = new URL(ret);
  newUrl.searchParams.set('utm_medium', 'share');
  ret = newUrl.href;
  return ret;
}

const getShareId = () => {
  // 随机数字符串
  function generateRandomString() {
    const characters =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const characterArray = characters.split('');
    const stringArray = [];
    const charactersLength = characterArray.length;
    for (let i = 0; i < 12; i++) {
      let randomIndex = Math.floor(Math.random() * charactersLength);
      stringArray.push(characterArray[randomIndex]);
    }
    return stringArray.join('');
  }
  return generateRandomString();
};

export const hasTapClientApi = (apiName) => {
  try {
    if (!window?.moo?.CONSTANT.IS_IN_TAPTAP) {
      return;
    }
    const actionList = JSON.parse(clientApi('actionList'));
    if (actionList.includes(apiName)) {
      return true;
    }
  } catch (e) {
    console.log(e);
  }
};

//客户端api通用调用方法
export function clientApi(apiName, params) {
  // console.log(apiName, params);
  if (!window?.moo?.CONSTANT.IS_IN_TAPTAP) {
    return;
  }
  if (params && typeof params === 'object') {
    params = JSON.stringify(params);
  }
  if (/(Android)/i.test(navigator.userAgent)) {
    return window.urlResource.TapTapAPI(apiName, params);
  }
  if (window.TapTapAPI && window.TapTapAPI[apiName]) {
    return window.TapTapAPI[apiName](params);
  } else {
    return window.TapTapAPI && window.TapTapAPI(apiName, params);
  }
}

const getMeta = (name) => {
  let result = '';
  let metaTag = document.querySelector(`meta[property="${name}"]`);
  if (metaTag) {
    result = metaTag.getAttribute('content');
  }
  return result;
};

export function getShareParams(url, title, desc, image, share_way) {
  let params = {
    'og:url': url || getMeta('og:url') || window.location.href,
    'og:title': title || getMeta('og:title'),
    'og:description': desc || getMeta('og:description'),
  };
  const INLINE_BASE64 = /^data:image\/.*;base64,/i;
  if (INLINE_BASE64.test(image)) {
    params['base64img'] = image;
  } else {
    params['og:image'] = image;
  }
  if (Number(share_way) > 0) {
    params['share_way'] = Number(share_way);
  }
  return params;
}

export function getImgShareParams(
  url,
  title,
  desc,
  image,
  qrCodeUrl,
  hashtag_ids,
  app_id,
  group_label_id,
  event_id,
  share_way
) {
  let params = {
    'og:url': url || getMeta('og:url') || window.location.href,
    'og:title': title || getMeta('og:title'),
    'og:description': desc || getMeta('og:description'),
  };
  const INLINE_BASE64 = /^data:image\/.*;base64,/i;
  if (INLINE_BASE64.test(image)) {
    params['base64img'] = image;
  } else {
    params['og:image'] = image;
  }
  if (qrCodeUrl) {
    params['qrcode_url'] = qrCodeUrl;
  }
  //发动态图文相关参数
  if (hashtag_ids) {
    hashtag_ids = hashtag_ids.filter((item) => {
      return item !== null && typeof item !== 'undefined' && item !== '';
    });
    if (hashtag_ids.length > 0) {
      params['hashtag_ids'] = hashtag_ids.join(',');
    }
  }
  if (app_id) {
    params['app_id'] = app_id;
  }
  if (group_label_id) {
    params['group_label_id'] = group_label_id;
  }
  if (event_id) {
    params['event_id'] = event_id;
  }
  if (Number(share_way) > 0) {
    params['share_way'] = Number(share_way);
  }
  return params;
}

// 绑定监听事件
export function initWebviewEmit() {
  // 非客户端不执行
  if (
    !(
      typeof window !== 'undefined' &&
      (window.TapTapAPI || (window.urlResource && window.urlResource.TapTapAPI))
    )
  ) {
    return;
  }
  // 绑定监听事件
  if (!window.webviewEvents) {
    window.webviewEvents = {};
  }
  if (!window.webviewEmit) {
    window.webviewEmit = (event, params) => {
      if (!window.webviewEvents[event]) {
        return;
      }
      window.webviewEvents[event].forEach((cb) => {
        cb(params);
      });
    };
  }

  if (!window.webviewOn) {
    window.webviewOn = (event, cb) => {
      if (!window.webviewEvents[event]) {
        window.webviewEvents[event] = [];
      }
      window.webviewEvents[event].push(cb);
    };
  }

  if (!window.webviewOff) {
    window.webviewOff = (event, cb) => {
      if (!window.webviewEvents[event]) {
        return;
      }

      const index = window.webviewEvents[event].findIndex(
        (item) => item === cb
      );

      if (index > -1) {
        window.webviewEvents[event].splice(index, 1);
      }
    };
  }

  window.webviewOn('notifyImageSaveStatusChanged', (callbackParams) => {
    const params = JSON.parse(callbackParams);
    const eventId = params['imageId'];
    if (saveImageCallbackMap.has(eventId)) {
      if (params['localStatus']) {
        saveImageCallbackMap.get(eventId)(params);
      }
      saveImageCallbackMap.delete(eventId);
    }
  });
}

export function removeWebviewEmit() {
  window.webviewOff && window.webviewOff('notifyImageSaveStatusChanged');
}

export default {
  getShareUrl,
  getClientXTP,
  getTapEnv,
  clientApi,
  getShareParams,
  getImgShareParams,
  openTapTapMomentEditor,
  initWebviewEmit,
  removeWebviewEmit,
  saveImageToAlbum,
  hasTapClientApi,
  getTapUserId,
  getHrefInTapTap,
};
